import {NIU_WINDOW,niuStatistics,niuValues} from './niuniu';

export function niuNumberAnalysis(history,hand,value) {
 const sample=history.slice(0,NIU_WINDOW);
 const stats=niuStatistics(sample,hand);
 const followers=sample.slice(1).flatMap((draw,i)=>niuValues(draw.numbers)[hand]===value&&Number(sample[i].issue)-Number(draw.issue)===1?[niuValues(sample[i].numbers)[hand]]:[]);
 return {...stats.rows[value],total:sample.length,followers:followers.length,next:Array.from({length:10},(_,n)=>({value:n,count:followers.filter(v=>v===n).length}))};
}

export function niuBacktest(history,hand) {
 const sample=history.slice(0,NIU_WINDOW);
 return sample.slice(0,-1).flatMap((draw,i)=>{
  if(Number(draw.issue)-Number(sample[i+1].issue)!==1) return [];
  const prediction=niuStatistics(sample.slice(i+1),hand).prediction;
  const actual=niuValues(draw.numbers)[hand];
  return [{issue:draw.issue,prediction,actual,hit:prediction===actual}];
 });
}

export function niuRoad(history,hand) {
 const draws=history.slice(0,NIU_WINDOW).reverse();
 let column=-1,row=0,previous;
 return draws.map((draw,i)=>{
  const value=niuValues(draw.numbers)[hand];
  const gap=i>0&&Number(draw.issue)-Number(draws[i-1].issue)!==1;
  if(i===0||gap||previous!==value) { column+=gap?2:1;row=0; } else row++;
  previous=value;
  return {issue:draw.issue,value,column,row,gap};
 });
}
